import { render, staticRenderFns } from "./MemoryMatch.vue?vue&type=template&id=4f6589f4&scoped=true"
import script from "./MemoryMatch.vue?vue&type=script&lang=ts"
export * from "./MemoryMatch.vue?vue&type=script&lang=ts"
import style0 from "./MemoryMatch.vue?vue&type=style&index=0&id=4f6589f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f6589f4",
  null
  
)

export default component.exports